
import React from "react";
import { Button } from "@/components/ui/button";
import { useUpdateActivity } from "@/services/activityService";
import { toast } from "@/components/ui/sonner";
import { Activity } from "@/components/activities/schema/activitySchema";

interface ActivityActionsProps {
  activity: Activity;
}

export const ActivityActions: React.FC<ActivityActionsProps> = ({ 
  activity 
}) => {
  const updateActivity = useUpdateActivity();

  const handleComplete = async () => {
    try {
      await updateActivity.mutateAsync({
        id: activity.id as string,
        status: 'completed'
      });
      toast.success("Activité marquée comme terminée");
    } catch (error) {
      toast.error("Erreur lors de la mise à jour du statut");
    }
  };

  if (activity.status !== "upcoming") {
    return null;
  }

  return (
    <div className="flex flex-col space-y-3 mb-6">
      <Button onClick={handleComplete} className="w-full">
        Marquer comme terminée
      </Button>
    </div>
  );
};
